"use client";

import { forwardRef, type MouseEventHandler, type ReactNode } from "react";

import * as S from "./EllipsisTooltip.style";

export type EllipsisTooltipProps = {
  children: ReactNode;
  tooltip?: ReactNode | null;
  tooltipMaxWidth?: string;
  sameWidthAsText?: boolean;
  isTooltipTextBold?: boolean;
  showTooltip?: boolean;
  tooltipPosition?: "left" | "right";
  onMouseEnter?: MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: MouseEventHandler<HTMLDivElement>;
};

const EllipsisTooltip = forwardRef<HTMLDivElement, EllipsisTooltipProps>(
  (
    {
      children,
      tooltip,
      tooltipMaxWidth = "40rem",
      sameWidthAsText = false,
      isTooltipTextBold = false,
      showTooltip = false,
      tooltipPosition = "left",
      onMouseEnter,
      onMouseLeave,
    },
    ref,
  ) => {
    return (
      <S.Wrapper
        ref={ref}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
        {showTooltip ? (
          <S.TooltipContainer
            $position={tooltipPosition}
            $maxWidth={tooltipMaxWidth}
            $sameWidthAsText={sameWidthAsText}
          >
            <S.TooltipBase>
              <S.TooltipClamp $isBold={isTooltipTextBold}>
                {tooltip}
              </S.TooltipClamp>
            </S.TooltipBase>
          </S.TooltipContainer>
        ) : null}
      </S.Wrapper>
    );
  },
);

EllipsisTooltip.displayName = "EllipsisTooltip";

export default EllipsisTooltip;
